import { render, staticRenderFns } from "./BidApprove.vue?vue&type=template&id=a5217daa&scoped=true&"
import script from "./BidApprove.vue?vue&type=script&lang=js&"
export * from "./BidApprove.vue?vue&type=script&lang=js&"
import style0 from "./BidApprove.vue?vue&type=style&index=0&id=a5217daa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5217daa",
  null
  
)

export default component.exports